export enum JWT {
  deniedReportsPermissions = '1',
  deniedContactsPermissions = '2',
  deniedCampaignsPermissions = '3',
  deniedActionsPermissions = '4',
}
